module.exports = __webpack_public_path__ + "media/stylesheets/images/main/sample592x124-2c03d4d8aab207954f2b88531d8d300d.jpeg";